import { defineComponent as _defineComponent } from 'vue';
import { BeosIconButton } from "@begentoOS/begento-ui";
import { ref } from "vue";
import { VSheet } from "vuetify/lib";
import { ICONS } from "@begentoOS/begento-ui";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosPlaygroundSection',
    props: {
        title: null,
        items: null
    },
    setup(__props) {
        const props = __props;
        const showItemsStates = ref(false);
        const dialog = ref(false);
        const widthDialog = ref("900px");
        return { __sfc: true, props, showItemsStates, dialog, widthDialog, BeosIconButton, VSheet, ICONS };
    }
});
